export type CommuteSearchCTAButton = {
  text: string;
  variant: string;
  sizeVariant: string;
  iconPlacement?: string;
  iconName: string;
  callout: {
    text: string;
    badgeVariant?: string;
  };
};

type LocationScreenStaticData = {
  commuteSearchCTAButton: CommuteSearchCTAButton;
};

export const getLocationScreenStaticData = (): LocationScreenStaticData => {
  return {
    commuteSearchCTAButton: {
      text: 'Search by travel time',
      variant: 'outline',
      sizeVariant: 'medium',
      iconName: 'ArrowRightTwoMd',
      iconPlacement: 'right',
      callout: {
        text: 'NEW',
        badgeVariant: 'white',
      },
    },
  };
};
